import script from "./SnippetDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SnippetDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SnippetDashboard.vue?vue&type=style&index=0&id=9c189e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c189e5c"]])

export default __exports__